<!-- eslint-disable vue/valid-v-model -->
<template>
  <DatePickerFrame>
    <div class="flex w-full gap-sm">
      <client-only>
        <VueDatePicker
          ref="datepicker1"
          v-model="date[0]"
          :clearable="false"
          :preset-dates="settings.presetRanges"
          :range="settings.range"
          :auto-apply="settings.autoApply"
          :week-num-name="settings.weekNumName"
          :enable-time-picker="settings.enableTimePicker"
          :position="settings.position as any"
          :month-name-format="settings.monthNameFormat as any"
          :locale="settings.locale"
          :min-date="mode === 'future' ? dayjs().toDate() : undefined"
          :max-date="date[1] as any"
          :show-now-button="true"
          :format="settings.format"
          :alt-position="isMobile ? settings.altPosition : null"
          :teleport="'body'"
          :teleport-center="isMobile"
          :auto-position="isMobile ? false : true"
          @closed="onDatepickerClosed()"
        >
          <template #dp-input="{ value }">
            <DatePickerInput :value="value" label="calendar.labels.rangeFrom" />
          </template>

          <template #preset-button>
            <div class="flex flex-col place-items-center gap-xs mt-sm">
              <b class="inline-block w-full text-left">{{
                t('calendar.presetRanges.selectRange')
              }}</b>
              <ButtonBasic
                v-for="preset of settings.presetRanges"
                :key="JSON.stringify(preset) + '_datepicker1'"
                :label="preset.label"
                :full-width="true"
                :slim="true"
                :style="EButtonStyle.AREA"
                classes="!w-full"
                @click="setRange(preset.value)"
              />
            </div>
          </template>
        </VueDatePicker>
        <VueDatePicker
          ref="datepicker2"
          v-model="date[1]"
          :clearable="false"
          :preset-dates="settings.presetRanges"
          :range="settings.range"
          :auto-apply="settings.autoApply"
          :week-num-name="settings.weekNumName"
          :enable-time-picker="settings.enableTimePicker"
          :position="settings.position as any"
          :month-name-format="settings.monthNameFormat as any"
          :locale="settings.locale"
          :min-date="date[0] as any"
          :max-date="mode === 'past' ? dayjs().toDate() : undefined"
          :show-now-button="true"
          :format="settings.format"
          :alt-position="isMobile ? (settings.altPosition as any) : null"
          :teleport="'body'"
          :teleport-center="isMobile"
          :auto-position="isMobile ? false : true"
          @closed="onDatepickerClosed()"
        >
          <template #dp-input="{ value }">
            <DatePickerInput :value="value" label="calendar.labels.rangeTo" />
          </template>

          <template #preset-button>
            <div class="flex flex-col place-items-center gap-xs mt-sm">
              <b class="inline-block w-full text-left">{{
                t('calendar.presetRanges.selectRange')
              }}</b>
              <ButtonBasic
                v-for="preset of settings.presetRanges"
                :key="JSON.stringify(preset) + '_datepicker2'"
                :label="preset.label"
                :full-width="true"
                :slim="true"
                :style="EButtonStyle.AREA"
                classes="!w-full"
                @click="setRange(preset.value)"
              />
            </div>
          </template>
        </VueDatePicker>
      </client-only>
    </div>
  </DatePickerFrame>
</template>

<script setup lang="ts">
import VueDatePicker from '@vuepic/vue-datepicker';
// INFO: Datepicker doesn't provide an export for it's props/type-interface anymore :(
import dayjs from 'dayjs';

import { EButtonStyle } from '@/@types/basic-button';
import ButtonBasic from '~~/src/components/components/core/basic-button/basic-button.vue';
import { useDatePicker } from './useDatePicker';
import DatePickerInput from '@/components/datePicker/components/input/datePickerInput.vue';
import DatePickerFrame from '@/components/datePicker/components/datePickerStyle/datePickerFrame.vue';
const { t } = useTrans();

const props = defineProps({
  modelValue: {
    type: Array as unknown as PropType<[Date, Date]>,
    required: true,
  },
  mode: {
    type: String as PropType<'all' | 'future' | 'past'>,
    default: 'future',
  },
});

const emit = defineEmits<{
  (e: 'update:modelValue', date: Date[] | any): void;
}>();

const {
  isMobile,
  settings,
  datepicker1,
  datepicker2,
  date,
  setRange,
  onDatepickerClosed,
} = useDatePicker(props, emit);
</script>
